
import { FALLBACK_IMAGES } from './constants';

/**
 * Provide high-quality fallback images when other methods fail
 */
export const getFallbackImage = (category: string): string => {
  console.log(`Getting fallback image for category: ${category}`);
  
  // Get category specific high-quality image or default
  const categoryImage = FALLBACK_IMAGES[category] || FALLBACK_IMAGES['default'];
  
  console.log(`Fallback image selected: ${categoryImage}`);
  return categoryImage;
};
